import React from 'react';
import edit from '../../../../../../assets/image/edit.svg';
import InputField from '../../../../../../component/form/FormInput';
import PageLoader from '../../../../../../component/PageLoader';

export default function ShipmentGeneral({ setForm, form, error, setError, loader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	return (
		<div>
			{loader.isGetData && loader.isLoader ? (
				<PageLoader />
			) : (
				<div className="p-3">
					<div className="d-flex align-items-center gap-4">
						<div className="col-4 col-xl-3 text-sm font-medium text-start">
							Default Dispatch Address
						</div>
						<div className="col-6 col-xl-6 my-2">
							<InputField
								label=""
								placeholder="dispatch address"
								type="text"
								required={true}
								autoFocus={true}
								value={form.default_dispatch_address}
								onChange={(value) => handleFormData('default_dispatch_address', value)}
								error={error?.default_dispatch_address}
							/>
						</div>
						<div>
							<img
								src={edit}
								alt="search-icon"
								width="24"
								height="24"
								onClick={() => {
									// setIsOpenModal(true);
								}}
								className="m-2 cursor-pointer"
							/>
						</div>
					</div>
					<div className="d-flex align-items-center gap-4 my-2">
						<div className="col-4 text-sm font-medium text-start">Notification Permissions</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.notification_permissions}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData('notification_permissions', !form.notification_permissions)
									}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
